import React, { useEffect, useState } from 'react';
import { Badge, Select } from '@mantine/core';
import DynamicLayout from 'src/components/Layout/DynamicLayout';
import { ProgressReportView } from 'src/components/ProgressReportView';
import { ParentChildViewReportSidebar } from 'src/components/Sidebars/Parent/ParentSidebarChildViewReport';
import { ProgressSkeleton } from 'src/components/Skeletons/ProgressReportSkeleton';
import useProgressReport from 'src/hooks/useProgressReport';
import { useAppDispatch, useAppSelector } from 'src/redux/redux-store/hooks';
import { setActiveSubject } from 'src/redux/redux-store/children/childrenReducer';

export const ParentsViewOfChildReport = () => {
  const dispatch = useAppDispatch();
  const { activeSubject, selectedChild, subjects: parentViewSubjects } = useAppSelector(
    (state) => state.child
  );
  const { progressReportData, loading, error } = useProgressReport();

  const [subjects, setSubjects] = useState<string[]>([]);
  const [currentSubject, setCurrentSubject] = useState<string | null>(null);

  useEffect(() => {
    setCurrentSubject(activeSubject);
  }, [activeSubject]);

  useEffect(() => {
    if (parentViewSubjects) {
      const subs = parentViewSubjects.map((s: any) =>
        typeof s === 'string' ? s : s.name
      );
      setSubjects(subs);
    } else {
      setSubjects([]);
    }
  }, [parentViewSubjects]);

  const handleSubjectChange = (val: string | null) => {
    if (val) {
      dispatch(setActiveSubject(val));
    }
  };

  const subjectSelect = (
    <Select
      placeholder="Select Subject"
      data={subjects}
      value={currentSubject}
      onChange={handleSubjectChange}
      searchable
      clearable={false}
      className="w-36"
      size="xs"
      disabled={subjects.length === 0}
    />
  );

  return (
    <DynamicLayout
      heading={
        <div className="flex items-center gap-4">
          <span className="text-xl font-bold">Progress Report</span>
          {selectedChild && (
            <Badge size="lg" variant="outline">
              Child: {selectedChild}
            </Badge>
          )}
          {subjectSelect}
        </div>
      }
      rightContent={subjectSelect}
      SidebarComponent={ParentChildViewReportSidebar}
    >
      {loading ? (
        <ProgressSkeleton />
      ) : error ? (
        <p className="text-red-500 p-4">{error}</p>
      ) : (
        <ProgressReportView data={progressReportData} />
      )}
    </DynamicLayout>
  );
};
